<template>
    <div class="container">
        <top></top>

        <list></list>

        <div class="major">
            <div class="content">
                <img src="../assets/img-Upload/bg.jpg" alt="">
            </div>

            <div class="main">
                <div class="Product-information">
                    <h2>
                        <span>软件上传</span>
                    </h2>
                    <div class="Application_download_main">
                        <el-upload
                                class="upload-demo"
                                drag
                                action="https://jsonplaceholder.typicode.com/posts/"
                                multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </div>
                </div>
            </div>
        </div>

        <bottom></bottom>
    </div>
</template>

<script>
    import top from "../components/common/Head";
    import list from "../components/common/Nav";
    import bottom from "../components/common/Foot";

    export default {
        name: "Upload",
        components: {
            top,
            list,
            bottom,
        },
        data(){
            return{
                active: 'A',
                block: 'A',
            }
        },
        methods:{
            up(show) {
                this.active = show;
                this.block = show;
            },
        }
    }
</script>

<style scoped>
    .content img{
        /*width: 100%;*/
        /*height: 100%;*/
        width: 1300px;
        height: 550px;
    }
    .Product-information{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Product-information h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Product-information h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Application_download_main ul{
        display: flex;
        flex-direction: column;
    }
    .Application_download_main ul li{
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
    }
    .Application_download_main ul li .left{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Application_download_main ul li .left img{
        width: 50px;
        height: 50px;
    }
    .Application_download_main ul li .left span{
        margin-left: 20px;
    }
    .Application_download_main ul li .right{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Application_download_main ul li .right img{
        cursor: pointer;
    }
</style>